<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="link"/>
          {{$t('socialNetworkAccounts')}}
        </h1>
      </div>
    </div>
    <social-network-account-list></social-network-account-list>
  </main>
</template>

<script>
import SocialNetworkAccountList from "@/views/client/client-info/SocialNetworkAccountList.vue";

export default {
  components: {SocialNetworkAccountList},
  data() {
    return {}
  },
  i18n: {
    messages: {
      en: {
        socialNetworkAccounts: "Social network account",
      },
      vi: {
        socialNetworkAccounts: "Tài khoản mạng xã hội",
      }
    }
  }
}
</script>